import Mutations from '../../odata/mutations';

export default { ...new Mutations('quote'), ...new Mutations('quotes') };
